import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { CategoryNav } from "./components/CategoryNav";
import { Hero } from "./components/Hero";
import { Shop } from "./components/Shop";
import { CartSheet } from "./components/CartSheet";
import { Reservations } from "./components/Reservations";
import { Wallet } from "./components/Wallet";
import { Journal } from "./components/Journal";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { LoginPage } from "./admin/LoginPage";
import { AdminDashboard } from "./admin/AdminDashboard";
import { AgentDashboard } from "./admin/AgentDashboard";

const Storefront = () => (
  <div className="App" data-testid="app-root">
    <Navbar />
    <CategoryNav />
    <main>
      <Hero />
      <Shop />
      <Reservations />
      <Wallet />
      <Journal />
      <Gallery />
      <Contact />
    </main>
    <Footer />
    <CartSheet />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Storefront />} />
            <Route
              path="/admin/login"
              element={
                <LoginPage
                  role="admin"
                  redirectTo="/admin"
                  title="Admin sign-in"
                  subtitle="Manage product prices for the whole store."
                />
              }
            />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route
              path="/agent/login"
              element={
                <LoginPage
                  role="agent"
                  redirectTo="/agent"
                  title="Agent sign-in"
                  subtitle="View bulk reservations and customer messages."
                />
              }
            />
            <Route path="/agent" element={<AgentDashboard />} />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "hsl(var(--card))",
                color: "hsl(var(--card-foreground))",
                border: "1px solid hsl(var(--border))",
                fontFamily: "'Inter', sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
